import { ProductPricingsService } from "./../../../services/documents/ProductPricingsService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ProductPricingsDetail } from "../../../components/Pages/Documents/ProductPricings/ProductPricingsDetail";
import { CreateProductPricingsDto } from "../../../dtos/documents/ProductPricings/CreateProductPricingsDto";
import { NFLookupProductPricings } from "../../../components/Shared/NewForms/NFLookupProductPricings";
import ProductPricingsList from "../../../components/Pages/Documents/ProductPricings/ProductPricingsList";

export const ProductPricings: IAppEntity = {
  entityType: "document",
  title: "Product Pricings",
  pluralTitle: "Product Pricings",
  apiUrl: "ProductPricings",
  apiEnum: ReferenceTypes.DocumentEmployeeDismissal,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ProductPricingsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ProductPricingsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupProductPricings, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ProductPricingsService("ProductPricings"),
  getEmptyModel: () => {
    const model: CreateProductPricingsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      productPricingGoods: [],
    };
    return model;
  },
};
